/*
 * MONTRELIO — calage vertical des flèches de carrousel (08.08.2026)
 *
 * Les flèches doivent tomber au CENTRE DE L'IMAGE du produit, pas au centre de la
 * carte (image + pastille + titre sur deux lignes + prix), sinon elles décrochent
 * vers le bas. En CSS pur c'est impossible à faire proprement : la hauteur du bloc
 * texte change d'une section à l'autre, d'un palier responsive à l'autre, et selon
 * que le titre tient sur une ou deux lignes.
 *
 * On mesure donc la première image du rail et on pose le décalage. Recalculé au
 * chargement des images, au redimensionnement et à chaque changement d'onglet.
 */
(function () {
  var RAILS = [
    /* Rails natifs Horizon : les flèches sont des enfants directs du composant,
       surtout pas celles des galeries qui vivent DANS les cartes. */
    { rail: 'slideshow-component.resource-list__carousel, slideshow-component.carousel-content', arrows: ':scope > slideshow-container > slideshow-arrows', mode: 'container' },
    /* Sections sur-mesure : boutons en position absolue dans le rail. */
    { rail: '.mtabs__pane', arrows: ':scope > .mtabs__nav', mode: 'button' },
    { rail: '.msc__rail', arrows: ':scope > .msc__nav', mode: 'button' },
    { rail: '.mtr-cols__wrap, .mtr-cols__viewport', arrows: ':scope > .mtr-cols__nav', mode: 'button' }
  ];

  function firstMedia(rail) {
    /* On vise le conteneur d'image plutôt que le <img> : il porte l'aspect-ratio,
       donc sa hauteur est connue même avant le chargement de l'image. */
    return rail.querySelector(
      '.mtabs__media, .msc__media, .mtr-cols__media, .card-gallery, .resource-card__image, .card__media, img'
    );
  }

  function place(rail, arrows, mode) {
    var media = firstMedia(rail);
    if (!media || !arrows.length) return;
    var mr = media.getBoundingClientRect();
    if (!mr.height) return;
    var center = mr.top - rail.getBoundingClientRect().top + mr.height / 2;

    if (mode === 'button') {
      arrows.forEach(function (b) {
        b.style.top = Math.round(center) + 'px';
        b.style.transform = 'translateY(-50%)';
      });
    } else {
      /* Le conteneur <slideshow-arrows> est en inset:0 et centre ses boutons :
         on le recentre en le calant en haut puis en poussant de la bonne hauteur. */
      arrows.forEach(function (box) {
        var btn = box.querySelector('.slideshow-control');
        var half = btn ? btn.getBoundingClientRect().height / 2 : 20;
        if (!half) half = 20;
        box.style.alignItems = 'flex-start';
        box.style.paddingBlockStart = Math.max(0, Math.round(center - half)) + 'px';
        box.style.paddingBlockEnd = '0px';
      });
    }
  }

  function sync() {
    RAILS.forEach(function (def) {
      document.querySelectorAll(def.rail).forEach(function (rail) {
        place(rail, Array.prototype.slice.call(rail.querySelectorAll(def.arrows)), def.mode);
      });
    });
  }

  var pending = null;
  function schedule() {
    if (pending) clearTimeout(pending);
    pending = setTimeout(function () { pending = null; sync(); }, 16);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);
  /* Changement d'onglet dans « Une montre pour chaque moment » : le rail affiché change. */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-mtab], .mtabs__tab')) setTimeout(schedule, 60);
  });
  /* Sections re-rendues par le thème (filtres, morph du panier, etc.). */
  document.addEventListener('shopify:section:load', schedule);
})();
